<script lang="ts">
  import PickupOrDeliveryWrapper from "@retailer/svelte/Cart/Page/PickupOrDelivery/PickupOrDeliveryWrapper.svelte";
  import type { Product } from "@shared/types/ProductLine";
  import CartStore from "@retailer/svelte/stores/CartStore";
  import { findProductForInventory } from "@retailer/svelte/CartWidget/v2/Services/CartEventTracking";
  import type { Distributor } from "@shared/types/Distributor";

  export let product: Product;
  export let Cart: any;
  export let distributor: Partial<Distributor>;
  export let justify: string = "end";
  export let callback: () => void;

  $: cartProduct = findProductForInventory($CartStore, product.inventory_id);
</script>

{#if distributor?.uses_warehouse_pickup}
  {#if cartProduct}
    <div class="fizz-styles">
      <PickupOrDeliveryWrapper {cartProduct} {Cart} {distributor} {callback} {justify} />
    </div>
  {/if}
{/if}
